import React from 'react';
import { InfoCircleTwoTone, WarningOutlined, WarningTwoTone } from '@ant-design/icons';
import { Collapse } from 'antd';

type Props = {
    message: string;
};

const DimensionConstrainedAlert = (props: Props) => {
    return (
        <div className="quickturn-dimension-constrained-alert w-100">
            <Collapse
                expandIconPosition="end"
                style={{
                    border: '1px solid #e8d57c',
                    borderRadius: '0.25rem',
                }}
            >
                <Collapse.Panel
                    key="1"
                    style={{
                        background: '#ffffe6',
                        borderRadius: '0.25rem',
                        border: 'none',
                        minHeight: '38px',
                    }}
                    header={
                        <div className="d-flex align-items-center font-weight-semibold">
                            <WarningTwoTone
                                twoToneColor="#e2c231"
                                style={{
                                    fontSize: '18px',
                                    marginRight: '10px',
                                }}
                            />
                            <span style={{ fontSize: '13px' }}>Dimension Constrained</span>
                        </div>
                    }
                >
                    <span
                        style={{
                            fontSize: '13px',
                        }}
                    >
                        {props.message}
                    </span>
                </Collapse.Panel>
            </Collapse>
        </div>
    );
};

export default DimensionConstrainedAlert;
